export default __webpack_public_path__ + "static/media/deliveryCharge.695abde3.png";